import { Flex } from '@aloft/toolkit-sui';

import React from 'react';
import { Root, createRoot } from 'react-dom/client';

import { MAP_PIN_STATUS_FILTERS } from './constants.ts';
import { PinStatusFilter } from './types.ts';

type StatusCheckboxesProps = {
  selected: PinStatusFilter[];
  onChange: (statuses: PinStatusFilter[]) => void;
};

const FILTERS = [
  MAP_PIN_STATUS_FILTERS['SELECTED COMPS'],
  MAP_PIN_STATUS_FILTERS.ACTIVE,
  MAP_PIN_STATUS_FILTERS.SOLD,
  MAP_PIN_STATUS_FILTERS.PENDING,
];

// eslint-disable-next-line react-refresh/only-export-components
const StatusCheckboxes: React.FC<StatusCheckboxesProps> = ({ selected, onChange }) => {
  const toggleStatus = (status: PinStatusFilter) => {
    const updated = selected.includes(status)
      ? selected.filter((s) => s !== status)
      : [...selected, status];
    onChange(updated);
  };

  return (
    <Flex padding={1} gap={1} flexDirection="column" flexWrap="wrap">
      {FILTERS.map((status) => (
        <label
          htmlFor={status}
          key={status}
          style={{ display: 'flex', alignItems: 'center', gap: 8, cursor: 'pointer' }}
        >
          {/* eslint-disable-next-line aloft/prefer-sound-ui-checkbox */}
          <input
            type="checkbox"
            id={status}
            checked={selected.includes(status)}
            onChange={() => toggleStatus(status)}
            style={{
              width: 16,
              height: 16,
              borderRadius: 4,
              cursor: 'pointer',
              position: 'relative',
              display: 'inline-block',
              verticalAlign: 'middle',
            }}
          />
          <span style={{ fontSize: '12px', fontWeight: 'bold' }}>
            {status.charAt(0).toUpperCase() + status.slice(1).toLowerCase()}
          </span>
        </label>
      ))}
    </Flex>
  );
};

type StatusFilterControlProps = StatusCheckboxesProps;

export class StatusFilterControl {
  private container: HTMLDivElement;
  private reactRoot?: Root;
  private props: StatusFilterControlProps;

  constructor(props: StatusFilterControlProps) {
    this.props = props;
    this.container = document.createElement('div');
    this.container.className = 'mapboxgl-ctrl mapboxgl-ctrl-group';
  }

  onAdd(): HTMLDivElement {
    this.reactRoot = createRoot(this.container);
    this.reactRoot.render(<StatusCheckboxes {...this.props} />);
    return this.container;
  }

  onRemove(): void {
    this.reactRoot?.unmount();
    this.container.remove();
  }

  updateProps(newProps: StatusFilterControlProps) {
    this.props = newProps;
    this.reactRoot?.render(<StatusCheckboxes {...this.props} />);
  }
}
